import axios from 'axios';
import { toast } from 'react-toastify';
import Toast from '../components/Common/Tostify/Toastify';
import { getCookie } from '../utility/helper';
import { SESSION_EXPIRED_MESSAGE } from '../utility/errorMessages';

const baseURL = process.env.REACT_APP_BASE_URL;
const notificationsURL = process.env.REACT_APP_NOTIFICATIONS_URL;

export const baseURL2 = notificationsURL;
let loginVal = true;

export const learnerId = getCookie('userid');

const http = axios.create({ baseURL: baseURL });
let isToastShown = false;
http.interceptors.request.use(
  (request) => {
    const applicationId = getCookie('applicationId');
    const token = getCookie('TOKEN_NAME');
    const config = getCookie('config');
    request.headers['x-tenant-id'] = applicationId;
    request.headers['x-access-token'] = token;
    request.headers['x-config'] = config;
    return request;
  },
  (err) => Promise.reject(err)
);
function clearAllCookies() {
  var cookies = document.cookie.split(';');

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf('=');
    var cookieName = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie =
      cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }
}
http.interceptors.response.use(
  (response) => {
    if (response?.data?.statusCode === 440 && loginVal === true) {
      Toast.error(SESSION_EXPIRED_MESSAGE);
      loginVal = false;
      setTimeout(() => {
        localStorage.clear();
        clearAllCookies();
        window.location.href = '/login';
      }, 2000);
    }
    return response;
  },
  async (error) => {
    if (error.response?.status === 440 && !isToastShown) {
      isToastShown = true;
      Toast.error(SESSION_EXPIRED_MESSAGE);
      loginVal = false;
      setTimeout(() => {
        window.location.href = '/login';
        localStorage.clear();
        clearAllCookies();
      }, 2000);
    }
    return Promise.reject({ ...error });
  }
);

export default http;

export const httpNotification = axios.create({ baseURL: baseURL2 });

httpNotification.interceptors.request.use(
  (request) => {
    const applicationId = getCookie('applicationId');
    const token = getCookie('TOKEN_NAME');
    request.headers['x-tenant-id'] = applicationId;
    request.headers['x-access-token'] = token;
    return request;
  },
  (err) => Promise.reject(err)
);

export const https = axios.create({ baseURL: baseURL });

https.interceptors.request.use(
  (request) => {
    const applicationId = getCookie('applicationId');
    const token = getCookie('TOKEN_NAME');
    request.headers['x-tenant-id'] = applicationId;
    request.headers['x-access-token'] = token;
    return request;
  },
  (err) => Promise.reject(err)
);
